import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="landing-page">
      {/* Header */}
      <header className="dark-header">
        <Link to="/" className="dark-logo-text">NIRAIE</Link>
        <nav className="dark-nav">
          <a href="/#features" className="dark-nav-link">Features</a>
          <a href="/#pricing" className="dark-nav-link">Pricing</a>
          <a href="/#faq" className="dark-nav-link">FAQ</a>
          <Link to="/contact" className="dark-nav-link">Contact</Link>
          <button className="btn-primary">Get Started</button>
        </nav>
      </header>

      {/* Policy Hero */}
      <section className="policy-hero">
        <div className="policy-hero-content">
          <h1 className="page-title">Privacy Policy</h1>
          <p className="page-subtitle">Last updated: December 13, 2024</p>
        </div>
      </section>

      {/* Policy Content */}
      <section className="policy-section">
        <div className="policy-container">
          <div className="policy-content">
            <h2 className="policy-heading">1. Information We Collect</h2>
            <p className="policy-text">
              At Niraie, we collect information that you provide directly to us when using our AI Tax Chat Engine. 
              This includes your name, email address, and any tax-related queries you submit to our platform. 
              We also automatically collect certain information about your device and how you interact with our service.
            </p>

            <h2 className="policy-heading">2. How We Use Your Information</h2>
            <p className="policy-text">
              We use the information we collect to provide, maintain, and improve our services. This includes:
            </p>
            <ul className="policy-list">
              <li>Processing your tax-related queries through our AI engine</li>
              <li>Sending you service updates and important notifications</li>
              <li>Improving our AI algorithms and service quality</li>
              <li>Preventing fraud and ensuring platform security</li>
              <li>Complying with legal obligations</li>
            </ul>

            <h2 className="policy-heading">3. Data Security</h2>
            <p className="policy-text">
              We implement industry-standard security measures to protect your personal information. Your data is 
              encrypted both in transit and at rest. We use secure servers and regularly update our security protocols 
              to protect against unauthorized access, alteration, disclosure, or destruction of your information.
            </p>

            <h2 className="policy-heading">4. Information Sharing</h2>
            <p className="policy-text">
              We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:
            </p>
            <ul className="policy-list">
              <li>With your explicit consent</li>
              <li>To comply with legal obligations or court orders</li>
              <li>To protect the rights, property, or safety of Niraie, our users, or the public</li>
              <li>With service providers who assist in our operations (under strict confidentiality agreements)</li>
            </ul>

            <h2 className="policy-heading">5. Cookies and Tracking</h2>
            <p className="policy-text">
              We use cookies and similar tracking technologies to enhance your experience on our platform. 
              These help us understand how you use our service and allow us to provide personalized features. 
              You can control cookie settings through your browser preferences.
            </p>

            <h2 className="policy-heading">6. Your Rights</h2>
            <p className="policy-text">
              You have the right to access, update, or delete your personal information at any time. You can also:
            </p>
            <ul className="policy-list">
              <li>Request a copy of the data we hold about you</li>
              <li>Opt-out of marketing communications</li>
              <li>Request data portability</li>
              <li>Lodge a complaint with relevant authorities</li>
            </ul>

            <h2 className="policy-heading">7. Data Retention</h2>
            <p className="policy-text">
              We retain your personal information only for as long as necessary to fulfill the purposes outlined 
              in this privacy policy, unless a longer retention period is required by law. When you delete your 
              account, we will delete your personal information within 30 days.
            </p>

            <h2 className="policy-heading">8. Children's Privacy</h2>
            <p className="policy-text">
              Our service is not directed to individuals under the age of 18. We do not knowingly collect personal 
              information from children. If you believe we have collected information from a child, please contact us immediately.
            </p>

            <h2 className="policy-heading">9. Changes to This Policy</h2>
            <p className="policy-text">
              We may update this privacy policy from time to time. We will notify you of any significant changes 
              by posting the new policy on this page and updating the "Last updated" date. Your continued use of 
              the service after changes constitutes acceptance of the updated policy.
            </p>

            <h2 className="policy-heading">10. Contact Us</h2>
            <p className="policy-text">
              If you have any questions about this Privacy Policy or our data practices, please contact us at:
            </p>
            <p className="policy-text">
              <strong>Email:</strong> niraiethechatengine@gmail.com<br />
              <strong>Phone:</strong> +91 93859 32082<br />
              <strong>Address:</strong> 97G/10/1 Teachers Colony, 5th Street West, Tuticorin-628008
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="dark-footer">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">NIRAIE</div>
            <p className="footer-tagline">AI-Powered Tax Intelligence for Everyone</p>
          </div>
          <div className="footer-section">
            <h4 className="footer-heading">Product</h4>
            <ul className="footer-links">
              <li><a href="/#features">Features</a></li>
              <li><a href="/#pricing">Pricing</a></li>
              <li><a href="/#faq">FAQ</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4 className="footer-heading">Legal</h4>
            <ul className="footer-links">
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
              <li><Link to="/refund-policy">Refund Policy</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4 className="footer-heading">Support</h4>
            <ul className="footer-links">
              <li><Link to="/contact">Contact</Link></li>
              <li><a href="#">Help Center</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2026 Niraie. All rights reserved.</p>
        </div>
      </footer>

      {/* Custom Credit Badge */}
      <div className="custom-credit">
        <span>Made with</span>
        <a href="https://sukraconsolv.com" target="_blank" rel="noopener noreferrer" className="custom-credit-link">
          SUKRA CONSOLV
        </a>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
